/**
 * Utility functions for qualitative factors
 */

export type QualitativeFactorBase = {
  name: string;
  isDefault: boolean;
};

/**
 * Sorts qualitative factors by isDefault first (default factors first), then alphabetically by name
 * @param factors - Array of qualitative factors to sort
 * @returns Sorted array of qualitative factors
 */
export const sortQualitativeFactors = (factors: QualitativeFactorBase[]) => {
  return [...factors].sort((a, b) => {
    // First sort by isDefault (default factors first)
    if (a.isDefault && !b.isDefault) return -1;
    if (!a.isDefault && b.isDefault) return 1;
    // Then sort by name alphabetically
    return a.name.localeCompare(b.name);
  });
};
